import React, { useEffect, useState, createContext, useContext } from 'react';
type UserRoleContextType = {
  isReader: boolean;
  toggleUserRole: () => void;
};
const UserRoleContext = createContext<UserRoleContextType | undefined>(undefined);
export const UserRoleProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Initialize from localStorage if available, default to true (reader)
  const [isReader, setIsReader] = useState<boolean>(() => {
    const savedUserRole = localStorage.getItem('userRole');
    return savedUserRole ? savedUserRole === 'reader' : true;
  });
  // Update localStorage when isReader changes
  useEffect(() => {
    localStorage.setItem('userRole', isReader ? 'reader' : 'vendor');
  }, [isReader]);
  const toggleUserRole = () => {
    setIsReader(prev => !prev);
  };
  return <UserRoleContext.Provider value={{
    isReader,
    toggleUserRole
  }} data-id="element-4125" data-mp="32tukirjs99uv">
      {children}
    </UserRoleContext.Provider>;
};
export const useUserRole = (): UserRoleContextType => {
  const context = useContext(UserRoleContext);
  if (context === undefined) {
    throw new Error('useUserRole must be used within a UserRoleProvider');
  }
  return context;
};